module.exports = __webpack_public_path__ + "static/mina-amini-45936ab534ee8cd8755626fa92203faa.jpg";